import { create } from "zustand";
import { config } from "../config";
import { prepareHeaders } from "../configuration/tokenHandling/prepareHeaders";
import { ScoreApiResponse } from "../shared/models/ScoreApiResponse";

interface Payload {
  assets_ids: string[];
  start_date?: string;
  end_date?: string;
}

interface ScoreState {
  data: ScoreApiResponse | null;
  loading: boolean;
  error: string | null;
  setLoading: (status: boolean) => void;
  postScore: (payload: Payload) => Promise<void>;
  clearScoreData: () => void;
}

const getHeaders = (): Headers => {
  let headers = new Headers();
  return prepareHeaders(headers);
};

const useScoreStore = create<ScoreState>((set) => ({
  data: null,
  loading: false,
  error: null,
  setLoading: (status: boolean) => {
    set({loading: status})
  },
  postScore: async (payload) => {
    set({ loading: true, error: null }); // Set loading to true, clear previous errors
    try {
      const response = await fetch(
        `${config.backend.SCORES_SERVICE}/v2/scores`,
        {
          method: "POST",
          headers: getHeaders(),
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData || "An error occurred"); // Throw error for catch block
      }

      const scoreData: ScoreApiResponse = await response.json();
      set({ data: scoreData, loading: false });
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    } catch (err: any) {
      set({ data: null, error: err.message, loading: false });
      console.error("Error posting score:", err); // Keep the console log
    }
  },
  clearScoreData: () => set({ data: null, error: null, loading: false }),
}));

export default useScoreStore;
